module.exports = __webpack_public_path__ + "img/cns_email_mac4.1c3602e1.png";